
<template>
  <div class="mt-2 flex  overflow-hidden flex-grow ">
    <div class="overflow-hidden  flex flex-col pb-4 flex-grow bg-trader-gray mr-2 ">

      <!--go back  -->
      <div class="w-full  h-10 ">
        <CGoBack/>
      </div>

      <!--Bearbeitung Weißer hintergrund  -->
      <div class=" flex-grow overflow-hidden px-10 h-full  flex  text-center justify-center">

        <div class=" overflow-auto bg-white rounded p-10  max-w-[1000px] flex-grow">

          <div class="flex items-center justify-between h-10 mb-4 w-full rounded">
            <div class="w-full bg-primary p-2 rounded">
              <span class="text-xl ">Neuer Markt</span>
            </div>
          </div>
          <div class="flex flex-col sm:flex-row w-full">
            <div class="w-full">
              <div class="flex mt-2 text-center w-full">
                <span class="bg-primary w-1/4 p-2 rounded">Kürzel</span>
                <input class="border p-2 rounded w-3/4"   v-model="name" :class="{'border p-2 rounded w-3/4 border-red-500' : showError && !name}" data-ui="name">
              </div>
              <div class="flex mt-2 text-center w-full">
                <span class="bg-primary w-1/4 p-2 rounded">Beschreibung / Ort</span>
                <input class="border p-2 rounded w-3/4" v-model="description" :class="{'border p-2 rounded w-3/4 border-red-500' : showError && !description}" data-ui="description">
              </div>
              <div class="flex mt-2 text-center w-full">
                <span class="bg-primary w-1/4 p-2 rounded">Status</span>
                <select class="border p-2 rounded w-3/4" v-model="isActive" :class="{'border p-2 rounded w-3/4 border-red-500' : showError && !isActive}" data-ui="isActive" >
                  <option value="yes" >Sichtbar </option>
                  <option value="no" >Nicht Sichtbar</option>
                </select>
              </div>
              <div class="flex mt-2  w-full" v-for="marketCustomField in marketCustomFields" :key="marketCustomField.idCustomField">
                <span class="bg-primary w-1/4 p-2 rounded">{{ marketCustomField.label }}</span>
                <input  class="border p-2 rounded w-3/4"  v-model="marketCustomField.fieldValue" :data-ui="marketCustomField.label">
              </div>
              <button @click="createMarket"  class=" mr-1 w-full rounded mt-2 p-3 bg-trader-green hover:bg-trader-blue hover:text-white transition duration-200 ease-in-out" data-ui="create-market-button">
                Erstellen
              </button>

            </div>
          </div>

        </div>
      </div>
    </div>

    <sidebar />
  </div>
</template>


<script >

import sidebar from "@/components/Administration/Sidebar.vue";
import {gql} from "@apollo/client/core";
import apolloClient from "@/apolloClient";
import router from "@/router";
import SignalBus  from "@/application/SignalBus";
import {eventBus} from "@/application/EventBus";
import SuccessConfirmation from "@/components/Dialogs/SuccessConfirmation.vue";
import CGoBack from "@/components/Administration/CGoBack.vue";
export default {
  components: {CGoBack, sidebar},
  data(){
    return{
      name: '',
      description: '',
      isActive: '',
      showError: false,
      market: null,
      marketCustomFields: [],
      idCustomField: 0,
      fieldValue: '',
      label: '',
      fieldName: '',
      markets: [],
      accordionIndex: 0,
    }
  },
  methods:{

    goBack(){
      router.push(`/administration`);
    },
    async getMarketCustomField() {
      const query = gql`
        query getMarketCustomField {
          getMarketCustomField  {
            idCustomField
            fieldValue
            fieldName
            label
          }
        }
      `;
      try {
        const variables = {marketId: this.marketId};
        const {data} = await apolloClient.query({query, variables});
        this.marketCustomFields = data.getMarketCustomField;
        
      } catch (error) {
        console.error(error);
      }
    },
    async createMarket(){
      let customFieldValues = [];
      this.marketCustomFields.forEach(function (marketCustomField) {
        customFieldValues.push({
          idMarketCustomField: marketCustomField.idCustomField,
          fieldValue: marketCustomField.fieldValue
        })
      })

      if(!this.isActive || !this.name || !this.description){
        this.showError = true;
        return
      }
      this.showError = false;

      const marketData = {
        name: this.name,
        description: this.description,
        isActive: this.isActive,
        customFieldValues: customFieldValues
      };
      // scheck if name is in markets name
      let exists = false;
      this.markets.forEach(market => {
        if(market.name == this.name){
          eventBus.openModal(SuccessConfirmation);
          eventBus.setData({
            title: "Markt existiert bereits",
            message: "Der Markt Kürzel existiert bereits",
          });
          exists = true;
        }
      })
      if(exists){
        return
      }
      const mutation = gql`
        mutation createMarket($market: CreateMarketInput!) {
          createMarket(market: $market) {
            success
          }
        }
      `;

      try {
        const variables = {
          market: marketData
        };
        const {data} = await apolloClient.mutate({mutation, variables});
        if (data.createMarket.success){
          eventBus.openModal(SuccessConfirmation);
          eventBus.setData({
            title: "Markt erstellt",
            message: "Der Markt wurde erstellt",
          });
          SignalBus.emit("sidebar-reload-market");
          router.push(`/administration/${this.accordionIndex}`);
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getAllMarkets() {
      const query = gql`
        query getAllMarkets {
          getAllMarkets  {
            marketId
            name
            description
            isActive
          }

        }
      `;
      try {
        const {data} = await apolloClient.query({query});
        this.markets = data.getAllMarkets;
      } catch (error) {
        console.error(error);
      }
    },
  },
  mounted() {
    this.getMarketCustomField();
    this.getAllMarkets();
  },
  watch: {
    // get accordionIndex from url
    '$route.params.accordionIndex': function (newId, oldId) {
      this.accordionIndex = newId;
    },
  },
  created() {
    this.accordionIndex = this.$route.params.accordionIndex
  },
}
</script>
